/** Durées / easings ISBD — motion discret, SaaS B2B */

export const motionDuration = {
  fast: 0.15,
  base: 0.22,
  page: 0.28,
} as const;

/** cubic-bezier(0.16, 1, 0.3, 1) */
export const motionEase = [0.16, 1, 0.3, 1] as const;

export const pageTransition = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: {
    duration: motionDuration.page,
    ease: motionEase,
  },
} as const;

export const pageTransitionReduced = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: motionDuration.fast },
} as const;

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
